export const INTERNAL_SOURCE = 'sentry:project';
export const INTERNAL_SOURCE_LOCATION = 'sentry://project_debug_file/';
